import React, { useState, useEffect } from 'react';
import { IconCheck, Divider } from 'cdk-radial';
import { useDispatch, useSelector } from 'react-redux';
import {clearSelectLocations, makeHeaderStepsClickable} from '../../../redux/connectedComponent/selectedLocations/selectedLocations.slice'
import { setScreen } from '../../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../../config/uiFactory.config';

function Step({ step, currentStep, goToStep, navigatedFromSubscriptionManagement, solutionData, isConfigureStep }) {
  const key = Object.keys(step);
  const dispatch = useDispatch();
  const state = useSelector(state => state);

  const urlProvisioning =
    state &&
    state.provisionSettings &&
    state.provisionSettings.urlProvisioning;

  const BLUE_BORDER_BOTTOM = '4px solid #006CFA';
  const LIGHT_BLUE_BORDER_BOTTOM = '4px solid #D9E9FE';
  const BLUE_BACKGROUND = '#006CFA';
  const GRAY_BACKGROND = 'gray';
  const BLACK_COLOR = {
    color: '#151b25',
    fontWeight: '500'
  };
  const GRAY_COLOR = {
    color: '#151b25',
    opacity: '70%'
  };
  const CURSOR_POINTER = {
    cursor: 'pointer'
  };
  const CURSOR_NO_DROP = {
    cursor: 'no-drop'
  };

  const [isStepClickable, setIsStepClickable] = useState(false);
  const [lableBulletAsCheckmark, setLableBulletAsCheckmark] = useState(false);
  const [borderStyle, setBorderStyle] = useState({});
  const [backgroundStyleForNumber, setBackgroundStyleForNumber] = useState({});
  const [colorStyleForLabel, setColorStyleForLabel] = useState({});
  const [cursorType, setCursorType] = useState(CURSOR_POINTER);
  useEffect(() => {

    if(isConfigureStep){
      setIsStepClickable(false);
      if (key[0] <= currentStep) {
        setBorderStyle({
          borderBottom: BLUE_BORDER_BOTTOM
        });
        setIsStepClickable(false);
      }
      if (key[0] < currentStep) {
        setLableBulletAsCheckmark(true);
      }
      if (Number(key[0]) === currentStep) {
        setBackgroundStyleForNumber({
          backgroundColor: BLUE_BACKGROUND
        });
        setColorStyleForLabel(BLACK_COLOR);
      }
    } else {
      if(state.selectLocationsSlice.headerStepsNotClickable)
      {
        setIsStepClickable(false);
        dispatch(makeHeaderStepsClickable());
      }
      if (key[0] <= currentStep) {
        setBorderStyle({
          borderBottom: BLUE_BORDER_BOTTOM
        });
        setIsStepClickable(true);
      } else {
        setBorderStyle({
          borderBottom: LIGHT_BLUE_BORDER_BOTTOM
        });
      }

      if (key[0] < currentStep) {
        setLableBulletAsCheckmark(true);
      } else {
        setLableBulletAsCheckmark(false);
      }

      if (Number(key[0]) === currentStep) {
        setBackgroundStyleForNumber({
          backgroundColor: BLUE_BACKGROUND
        });
      } else {
        setBackgroundStyleForNumber({
          backgroundColor: GRAY_BACKGROND
        });
      }

      if (Number(key[0]) === currentStep || isStepClickable) {
        setCursorType(CURSOR_POINTER);
        setColorStyleForLabel(BLACK_COLOR);
      } else {
        setCursorType(CURSOR_NO_DROP);
        setColorStyleForLabel(GRAY_COLOR);
      }
    }
  }, [currentStep,state.selectLocationsSlice.headerStepsNotClickable, isConfigureStep]);

  useEffect(() => {
    if (Number(key[0]) === currentStep || isStepClickable) {
      setCursorType(CURSOR_POINTER);
      setColorStyleForLabel(BLACK_COLOR);
    } else {
      setCursorType(CURSOR_NO_DROP);
      setColorStyleForLabel(GRAY_COLOR);
    }
  },
  [isStepClickable]);

  function onStepClicked() {
    if (isStepClickable && Number(key[0]) !== currentStep) {
      goToStep(Number(key[0]));
    }
  }

  return (

    <div
      onClick={() => onStepClicked()}
      className="stepper-header-step"
      style={{ ...borderStyle, ...cursorType }}
    >
      {
        step[key[0]] === 'Select Locations' ? <Divider className='step-divider-end'/> : <Divider className='step-divider'/>
      }
      <div className='step-detail'>
        {lableBulletAsCheckmark ? (
          <IconCheck
            onClick={() => onStepClicked()}
            className="stepper-header-step-icon-check"
            style={cursorType}
          />
        ) : (
          <label
            onClick={() => onStepClicked()}
            className="stepper-header-step-number"
            style={{ ...backgroundStyleForNumber, ...cursorType }}
          >
            {key[0]}
          </label>
        )}
        <label
          onClick={() => onStepClicked()}
          className="stepper-header-step-label"
          style={{ ...colorStyleForLabel, ...cursorType }}
        >
          {step[key[0]]}
        </label>
      </div>
      {
        urlProvisioning
        ? step[key[0]] === 'Complete Configuration' ? <Divider className='step-divider-end'/> : <Divider/>
        : step[key[0]] === 'Review Subscription' || step[key[0]] === 'Review Activation'  ? <Divider className='step-divider-end'/> : <Divider/>
      }
    </div>
  );
}

export default Step;
